module.exports = __webpack_public_path__ + "static/media/Artboard–20.cb4bbaa3.png";